/**
 * Contorno das 27 UFs para o mapa de visitas (spec mapa-contorno-brasil, design §5; ADR-032).
 *
 * O asset é carregado por `import()` dinâmico: o Vite gera um chunk próprio, publicado com o SPA (sem chamada a
 * domínio externo) e baixado só quando a tela do mapa o pede. A forma é conferida antes de ser usada — um
 * arquivo inesperado vira erro, e a tela cai no fundo liso com aviso (Req 3 AC4).
 */
import type { Caixa, ContornoUfs } from '../components/mapa/projecao';

function caixaValida(v: unknown): v is Caixa {
  return Array.isArray(v) && v.length === 4 && v.every((n) => typeof n === 'number' && Number.isFinite(n));
}

/** Confere a forma do contorno; lança erro se não for a esperada. */
export function validarContornoUfs(v: unknown): ContornoUfs {
  const c = v as Partial<ContornoUfs> | null;
  const ok =
    c !== null &&
    typeof c === 'object' &&
    typeof c.versao === 'string' &&
    typeof c.projecao?.grade === 'number' &&
    caixaValida(c.brasil?.bbox) &&
    Array.isArray(c.ufs) &&
    c.ufs.length > 0 &&
    c.ufs.every(
      (u) =>
        typeof u?.sigla === 'string' &&
        /^[A-Z]{2}$/.test(u.sigla) &&
        typeof u.nome === 'string' &&
        caixaValida(u.bbox) &&
        typeof u.d === 'string' &&
        u.d.startsWith('M'),
    );
  if (!ok) {
    throw new Error('Contorno do mapa em formato inesperado');
  }
  return c as ContornoUfs;
}

/** Carrega o contorno (chunk próprio). */
export async function carregarContornoUfs(): Promise<ContornoUfs> {
  const modulo = await import('../assets/mapa/ufs-brasil.json');
  return validarContornoUfs(modulo.default);
}
